import './FaqResults.scss';

import React, { useState } from 'react';

import FaqItem from '../FaqCategories/FaqItem';

const FaqSearch = ({isSearch}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [postsByTerm, setPostsByTerm] = useState([]);


  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const newUrl = new URL(window.location);
    newUrl.searchParams.delete('category');
    newUrl.searchParams.set('search', searchTerm);
    window.history.pushState({}, '', newUrl);

    $.ajax({
      url: '/wp/wp-admin/admin-ajax.php',
      type: 'GET',
      dataType: 'json',
      data: {
        action: 'search_posts',
        term: searchTerm,
      },
      success: function (response) {
        if (response.length > 0) {
          setPostsByTerm(response);
        } else {
          setPostsByTerm([]);
        }
        setIsLoaded(true);
        setIsLoading(false);
      },
      error: function () {
        console.error('Error fetching search results.');
      },

    });
  };

  const clearSearch = () => {
    setSearchTerm('');
    const baseUrl = window.location.pathname;
    window.history.pushState({}, '', baseUrl);
  }

  const FaqResultsSearchList = (postsByTerm, term) => {
    const list = postsByTerm.postsByTerm;
    const resultCount = list.length;
    const safeSearchTerm = typeof term === 'string' ? term.trim() : '';

    return (
      <div className="FaqResults__CategoryList FaqResults__SearchList" aria-live="polite" aria-atomic={true}>
        {isLoading ? (
            <div className="FaqResults__Loader" />
        ) : (
          <>
          {resultCount === 0 && safeSearchTerm == '' ? (
            <div className="FaqResults__ErrorMessage">
              <h2 className="FaqResults__ErrorMessageTitle">Din sökning gav tyvärr inga resultat.</h2>
              <p className="FaqResults__ErrorMessageText">Dubbelkolla om du råkat stava fel eller testa att ange ett annat sökord.</p>
            </div>
          ) : (
          <>
            <div class="FaqResults__ResultMessage">
              <h2>Din sökning gav {resultCount} resultat.</h2>
              <button onClick={clearSearch}>Rensa sökning</button>
            </div>
            <ul class="FaqResults__AccordionList">
                {Object.values(list).map(post => (
                  <FaqItem question={post.title} answer={post?.answer} />
                )
              )}
            </ul>
          </>
        )}
        </>
      )}
    </div>
 )}

  return (
    <>
      <form role="search" method="get" className="faq-search__form" id="faq-search-form" onSubmit={handleSearchSubmit}>
        <label className="sr-only" htmlFor="faq-search-input">
          Sök bland våra frågor och svar:
        </label>
        <input
          className="faq-search__input"
          type="text"
          value={searchTerm}
          name="faq-search-input"
          id="faq-search-input"
          placeholder="Sök bland frågor och svar"
          onChange={(e) => setSearchTerm(e.target.value || '')}
        />
        <label className="faq-search__submit">
          <label className="sr-only" htmlFor="faq-search-submit">
            Skicka
          </label>
          <input type="submit" id="faq-search-submit" value="Submit" />
        </label>
      </form>
      {isSearch ? (
        <div className="FaqResults">
          <FaqResultsSearchList postsByTerm={postsByTerm} searchTerm={searchTerm} />
        </div>
       ) : null }
    </>
  );
};


export default FaqSearch;




